<div class="g-0">
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-circle-info"></i>
                                <span>Subsemnatul</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onSubsemnatulInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.adresa_domiciliu"
                                        value="adresa_domiciliu">Domiciliu</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.adresa_domiciliu_anterior"
                                        value="adresa_domiciliu_anterior">Domiciliu
                                        Anterior</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.adresa_resedinta"
                                        value="adresa_resedinta">Reședință</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <ng-container *ngIf="selectedSubsemnatulStatus === 'info'">
                        <table class="table table-condensed table-wrapper-box">
                            <tbody>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Nume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.nume ? (cerere.cetatean?.nume + ' ' +
                                        cerere.cetatean?.prenume) : 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CNP</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.cnp || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Telefon</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.telefon || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Email</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.email || 'N/A' }}</td>
                                </tr>
                                <tr *ngIf="cerere.cetatean?.nume_tata">
                                    <td class="text-center">
                                        <strong>Prenume tată</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.nume_tata }}</td>
                                </tr>
                                <tr *ngIf="cerere.cetatean?.nume_mama">
                                    <td class="text-center">
                                        <strong>Prenume mamă</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.nume_mama }}</td>
                                </tr>
                                <!-- <tr>
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.observatii || 'N/A' }}</td>
                                </tr> -->
                            </tbody>
                        </table>
                    </ng-container>
                    <ng-container *ngIf="selectedSubsemnatulStatus === 'adresa_domiciliu'">
                        <app-address *ngIf="cerere.adresa_domiciliu" [address]="cerere.adresa_domiciliu"></app-address>
                    </ng-container>
                    <ng-container *ngIf="selectedSubsemnatulStatus === 'adresa_domiciliu_anterior'">
                        <app-address *ngIf="cerere.adresa_domiciliu_anterior"
                            [address]="cerere.adresa_domiciliu_anterior"></app-address>
                    </ng-container>
                    <ng-container *ngIf="selectedSubsemnatulStatus === 'adresa_resedinta'">
                        <app-address *ngIf="cerere.adresa_resedinta" [address]="cerere.adresa_resedinta"></app-address>
                    </ng-container>
                    <ng-container *ngIf="cerere.programare_eveniment || cerere.programare_documente">
                        <h4 class="text-center w-100"><strong>Programare</strong></h4>
                        <table class="table table-condensed table-wrapper-box">
                            <tbody>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Locație</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.locatie }}</td>
                                </tr>
                                <tr *ngIf="cerere.programare_eveniment">
                                    <td width="40%" class="text-center">
                                        <strong>Programare Eveniment</strong>
                                    </td>
                                    <td class="text-left">{{
                                        cerere.programare_eveniment.data_ora | date:'dd-MM-yyyy HH:mm'
                                        }}</td>
                                </tr>
                                <tr *ngIf="cerere.programare_documente">
                                    <td width="40%" class="text-center">
                                        <strong>Programare Depunere Documente</strong>
                                    </td>
                                    <td class="text-left">{{
                                        cerere.programare_documente.data_ora | date:'dd-MM-yyyy HH:mm'
                                        }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>